import $ from 'jquery';
import ScrollMagic from 'scrollmagic';

class Common { 
	constructor() {
		this.controller = new ScrollMagic.Controller();
	}

	init() {
        this.bindEvents();

		this.scrollElementUp();
		this.fadeIn();
		this.initExternalLinks();
	}

	bindEvents() {
	}

	initExternalLinks() {
		$('a:not(.open-self)').each((index, element) => {
            let a = new RegExp(`/${window.location.host}/`);

            if (!a.test(element.href) && element.href !== '') {
                $(element).click((event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    window.open(element.href, '_blank');
                });
            }
        });
    }

	scrollElementUp() {
		let offsetHeight = window.innerHeight / 4;
		let revealElements = document.getElementsByClassName('scroll-element-up');

		[...revealElements].forEach((element, index) => {
			new ScrollMagic.Scene({
				triggerElement: element,
				offset: offsetHeight,
				triggerHook: 5,
				reverse: false,
			})
				.setClassToggle(element, 'visible') // add class toggle
				.addTo(this.controller);
		});

		let revealArrows = document.getElementsByClassName('arrow-animated');

		[...revealArrows].forEach((element, index) => {
			new ScrollMagic.Scene({
				triggerElement: element,
				offset: offsetHeight / 2,
				triggerHook: 5,
				reverse: false,
			})
				.setClassToggle(element, 'visible') // add class toggle
				.addTo(this.controller);
		});
	}

	fadeIn() {
		let offsetHeight = window.innerHeight / 4;
		let revealElements = document.getElementsByClassName('fade-element-in');
		[...revealElements].forEach((element, index) => {
			new ScrollMagic.Scene({
				triggerElement: element,
				offset: offsetHeight,
				triggerHook: 5,
				reverse: false,
			})
				.setClassToggle(element, 'visible')
				.addTo(this.controller);
		});

		let revealChildElements = document.getElementsByClassName('fade-children-in');
		[...revealChildElements].forEach((element, index) => {
			new ScrollMagic.Scene({
				triggerElement: element,
				offset: offsetHeight,
				triggerHook: 5,
				reverse: false,
			})
				.setClassToggle(element, 'visible')
				.addTo(this.controller);
		});
	}
}

export default Common;